export var DayQuantityText;
(function (DayQuantityText) {
    DayQuantityText["InvalidConfiguration"] = "Invalid Day Quantity module configuration";
})(DayQuantityText || (DayQuantityText = {}));
